export class VesselData {

  vesselName: string = '';

  vesselRegistrationNumber: string = '';  // Registration number for the vessel (VRN)

  isRecognized: boolean = false; // Whether or not the vessel is recognized (not currently used)

  isChecked: boolean = false; // Whether or not the vessel is checked in a list

  constructor(
    vname: string = '',
    regNum: string = '',
    checked: boolean = false) {

    this.vesselName = vname;
    this.vesselRegistrationNumber = regNum;
    this.isChecked = checked;

  }

  public toString(): string {
      return this.vesselName + ' (VRN: ' + this.vesselRegistrationNumber + ')';
  }

  public isValid(): boolean {
      return !!this.vesselName && !!this.vesselRegistrationNumber;
  }

  // transform anonymous data into vessel data object
  public static transformAnonymous(vessel: any): VesselData {

    if (!vessel) {
      return new VesselData();
    }

    return new VesselData(
      vessel.vesselName ?? '',
      vessel.vesselRegistrationNumber ?? '',
      vessel.isChecked ?? false
    );
    
  }

  // check if user vessels are defined
  public static transformAnonArray(vessels: any): VesselData[] {

    // if vessels do not exist, return an empty array
    if (!vessels) {
      return [];
    }

    let userVessels: VesselData[] = [];
    for (let vessel of vessels) {
      userVessels.push(VesselData.transformAnonymous(vessel));
    }
    return userVessels;

  }

}
